// src/hooks/useAuth.js
import { createContext, useContext, useState, useCallback } from 'react';
import { login as apiLogin, logout as apiLogout } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gfm3_user')); }
    catch { return null; }
  });

  const signIn = useCallback(async (username, password) => {
    const res = await apiLogin({ username, password });
    const { token, user: u } = res.data;
    localStorage.setItem('gfm3_token', token);
    localStorage.setItem('gfm3_user', JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  const signOut = useCallback(async () => {
    try { await apiLogout(); } catch {}
    localStorage.removeItem('gfm3_token');
    localStorage.removeItem('gfm3_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth doit être utilisé dans un <AuthProvider>');
  return ctx;
}
